import VopProviderPage from '@/pages/vopProvider/VopProviderPage.vue'
import VopProviderDetails from '@/pages/vopProvider/VopProviderDetails.vue'

export default [
  {
    path: '/vopProvider/',
    component: VopProviderPage,
    props: true
  },
  {
    path: '/vopProvider/:mode/:IdVopProvide',
    component: VopProviderDetails,
    props: true
  }
]
